/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getUnit} from '../api'

 export const useQueryGetUnit = createReactQueryHook('getUnit', getUnit)
